import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="processing-timeout"
// Reveals a refresh prompt if a batch is still "Processing..." after the delay. Each Turbo re-render
// resets the timer, so it only fires when an update never arrives (a stuck job).
export default class extends Controller {
  static targets = ["spinner", "message"];
  static values = { delay: { type: Number, default: 30000 } };

  connect() {
    this.timer = setTimeout(() => {
      this.spinnerTarget.classList.add("hidden");
      this.messageTarget.classList.remove("hidden");
    }, this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  refresh() {
    window.location.reload();
  }
}
